import { stimulusApplication } from "lib/stimulus_app"

// La instancia, su configuración (debug) y window.Stimulus viven en lib/stimulus_app, que
// garantiza una sola aplicación aunque Turbo re-evalúe los packs en cada navegación.
const application = stimulusApplication()

export { application }
